import { useMutation } from '@tanstack/react-query';
import { useBridgeContext } from '@sendible/shared-state-bridge';
import { fetchWithHeaders } from '@sendible/common';
import endpoints from '../../data-layer/endpoints';
import { useQueryWithAccessToken } from '../../data-layer/useReactQueryWithAccessToken';

const { GetTogglableFeatures, EnableFeatureTag, DisableFeatureTag } = endpoints;

export const useGetTogglableFeatures = () =>
  useQueryWithAccessToken<TogglableFeature[]>([GetTogglableFeatures.endpoint], {
    staleTime: Infinity,
    cacheTime: 0,
  });

export const useEnableFeatureTag = () => {
  const [{ user }] = useBridgeContext();
  const access_token = user?.accessToken;
  const { method, endpoint } = EnableFeatureTag;

  return useMutation({
    mutationFn: async (payload: ToggleFeatureParams) => {
      return fetchWithHeaders({
        method,
        url: endpoint,
        params: { access_token },
        body: payload,
      }).then((response: unknown) => (response as { result?: unknown }).result);
    },
    onSuccess: () => window.location.reload(),
  });
};

export const useDisableFeatureTag = () => {
  const [{ user }] = useBridgeContext();
  const access_token = user?.accessToken;
  const { method, endpoint } = DisableFeatureTag;

  return useMutation({
    mutationFn: async (payload: ToggleFeatureParams) => {
      return fetchWithHeaders({
        method,
        url: endpoint,
        params: { access_token },
        body: payload,
      }).then((response: unknown) => (response as { result?: unknown }).result);
    },
    onSuccess: () => window.location.reload(),
  });
};
